// Country list with ISO codes and localized names
export const countryOptions = [
    { code: "af", en: "Afghanistan", se: "Afghanistan" },
    { code: "al", en: "Albania", se: "Albanien" },
    { code: "dz", en: "Algeria", se: "Algeriet" },
    { code: "vi", en: "U.S. Virgin Islands", se: "Amerikanska Jungfruöarna" },
    { code: "as", en: "American Samoa", se: "Amerikanska Samoa" },
    { code: "ad", en: "Andorra", se: "Andorra" },
    { code: "ao", en: "Angola", se: "Angola" },
    { code: "ai", en: "Anguilla", se: "Anguilla" },
    { code: "aq", en: "Antarctica", se: "Antarktis" },
    { code: "ag", en: "Antigua and Barbuda", se: "Antigua och Barbuda" },
    { code: "ar", en: "Argentina", se: "Argentina" },
    { code: "am", en: "Armenia", se: "Armenien" },
    { code: "aw", en: "Aruba", se: "Aruba" },
    { code: "au", en: "Australia", se: "Australien" },
    { code: "az", en: "Azerbaijan", se: "Azerbajdzjan" },
    { code: "bs", en: "Bahamas", se: "Bahamas" },
    { code: "bh", en: "Bahrain", se: "Bahrain" },
    { code: "bd", en: "Bangladesh", se: "Bangladesh" },
    { code: "bb", en: "Barbados", se: "Barbados" },
    { code: "be", en: "Belgium", se: "Belgien" },
    { code: "bz", en: "Belize", se: "Belize" },
    { code: "bj", en: "Benin", se: "Benin" },
    { code: "bm", en: "Bermuda", se: "Bermuda" },
    { code: "bt", en: "Bhutan", se: "Bhutan" },
    { code: "bo", en: "Bolivia", se: "Bolivia" },
    { code: "ba", en: "Bosnia and Herzegovina", se: "Bosnien och Hercegovina" },
    { code: "bw", en: "Botswana", se: "Botswana" },
    { code: "bv", en: "Bouvet Island", se: "Bouvetön" },
    { code: "br", en: "Brazil", se: "Brasilien" },
    { code: "vg", en: "British Virgin Islands", se: "Brittiska Jungfruöarna" },
    { code: "io", en: "British Indian Ocean Territory", se: "Brittiska territoriet i Indiska Oceanen" },
    { code: "bn", en: "Brunei", se: "Brunei" },
    { code: "bg", en: "Bulgaria", se: "Bulgarien" },
    { code: "bf", en: "Burkina Faso", se: "Burkina Faso" },
    { code: "mm", en: "Myanmar", se: "Burma" },
    { code: "bi", en: "Burundi", se: "Burundi" },
    { code: "ky", en: "Cayman Islands", se: "Caymanöarna" },
    { code: "cf", en: "Central African Republic", se: "Centralafrikanska republiken" },
    { code: "cl", en: "Chile", se: "Chile" },
    { code: "co", en: "Colombia", se: "Colombia" },
    { code: "ck", en: "Cook Islands", se: "Cooköarna" },
    { code: "cr", en: "Costa Rica", se: "Costa Rica" },
    { code: "cy", en: "Cyprus", se: "Cypern" },
    { code: "dk", en: "Denmark", se: "Danmark" },
    { code: "cd", en: "Democratic Republic of the Congo", se: "Demokratiska republiken Kongo" },
    { code: "dj", en: "Djibouti", se: "Djibouti" },
    { code: "dm", en: "Dominica", se: "Dominica" },
    { code: "do", en: "Dominican Republic", se: "Dominikanska republiken" },
    { code: "ec", en: "Ecuador", se: "Ecuador" },
    { code: "eg", en: "Egypt", se: "Egypten" },
    { code: "gq", en: "Equatorial Guinea", se: "Ekvatorialguinea" },
    { code: "sv", en: "El Salvador", se: "El Salvador" },
    { code: "ci", en: "Ivory Coast", se: "Elfenbenskusten" },
    { code: "er", en: "Eritrea", se: "Eritrea" },
    { code: "ee", en: "Estonia", se: "Estland" },
    { code: "et", en: "Ethiopia", se: "Etiopien" },
    { code: "fk", en: "Falkland Islands", se: "Falklandsöarna" },
    { code: "fj", en: "Fiji", se: "Fiji" },
    { code: "ph", en: "Philippines", se: "Filippinerna" },
    { code: "fi", en: "Finland", se: "Finland" },
    { code: "fr", en: "France", se: "Frankrike" },
    { code: "gf", en: "French Guiana", se: "Franska Guyana" },
    { code: "pf", en: "French Polynesia", se: "Franska Polynesien" },
    { code: "tf", en: "French Southern Territories", se: "Franska södra territorierna" },
    { code: "fo", en: "Faroe Islands", se: "Färöarna" },
    { code: "ae", en: "United Arab Emirates", se: "Förenade Arabemiraten" },
    { code: "ga", en: "Gabon", se: "Gabon" },
    { code: "gm", en: "Gambia", se: "Gambia" },
    { code: "ge", en: "Georgia", se: "Georgien" },
    { code: "gh", en: "Ghana", se: "Ghana" },
    { code: "gi", en: "Gibraltar", se: "Gibraltar" },
    { code: "gr", en: "Greece", se: "Grekland" },
    { code: "gd", en: "Grenada", se: "Grenada" },
    { code: "gl", en: "Greenland", se: "Grönland" },
    { code: "gp", en: "Guadeloupe", se: "Guadeloupe" },
    { code: "gu", en: "Guam", se: "Guam" },
    { code: "gt", en: "Guatemala", se: "Guatemala" },
    { code: "gg", en: "Guernsey", se: "Guernsey" },
    { code: "gn", en: "Guinea", se: "Guinea" },
    { code: "gw", en: "Guinea-Bissau", se: "Guinea Bissau" },
    { code: "gy", en: "Guyana", se: "Guyana" },
    { code: "ht", en: "Haiti", se: "Haiti" },
    { code: "hm", en: "Heard Island and McDonald Islands", se: "Heard- och McDonaldsöarna" },
    { code: "hn", en: "Honduras", se: "Honduras" },
    { code: "hk", en: "Hong Kong", se: "Hongkong" },
    { code: "in", en: "India", se: "Indien" },
    { code: "id", en: "Indonesia", se: "Indonesien" },
    { code: "iq", en: "Iraq", se: "Irak" },
    { code: "ir", en: "Iran", se: "Iran" },
    { code: "ie", en: "Ireland", se: "Irland" },
    { code: "is", en: "Iceland", se: "Island" },
    { code: "im", en: "Isle of Man", se: "Isle of Man" },
    { code: "il", en: "Israel", se: "Israel" },
    { code: "it", en: "Italy", se: "Italien" },
    { code: "jm", en: "Jamaica", se: "Jamaica" },
    { code: "jp", en: "Japan", se: "Japan" },
    { code: "ye", en: "Yemen", se: "Jemen" },
    { code: "je", en: "Jersey", se: "Jersey" },
    { code: "jo", en: "Jordan", se: "Jordanien" },
    { code: "cx", en: "Christmas Island", se: "Julön" },
    { code: "kh", en: "Cambodia", se: "Kambodja" },
    { code: "cm", en: "Cameroon", se: "Kamerun" },
    { code: "ca", en: "Canada", se: "Kanada" },
    { code: "cv", en: "Cape Verde", se: "Kap Verde" },
    { code: "kz", en: "Kazakhstan", se: "Kazakstan" },
    { code: "ke", en: "Kenya", se: "Kenya" },
    { code: "cn", en: "China", se: "Kina" },
    { code: "kg", en: "Kyrgyzstan", se: "Kirgizistan" },
    { code: "ki", en: "Kiribati", se: "Kiribati" },
    { code: "cc", en: "Cocos (Keeling) Islands", se: "Kokosöarna" },
    { code: "km", en: "Comoros", se: "Komorerna" },
    { code: "cg", en: "Republic of the Congo", se: "Kongo-Brazzaville" },
    { code: "hr", en: "Croatia", se: "Kroatien" },
    { code: "cu", en: "Cuba", se: "Kuba" },
    { code: "kw", en: "Kuwait", se: "Kuwait" },
    { code: "la", en: "Laos", se: "Laos" },
    { code: "ls", en: "Lesotho", se: "Lesotho" },
    { code: "lv", en: "Latvia", se: "Lettland" },
    { code: "lb", en: "Lebanon", se: "Libanon" },
    { code: "lr", en: "Liberia", se: "Liberia" },
    { code: "ly", en: "Libya", se: "Libyen" },
    { code: "li", en: "Liechtenstein", se: "Liechtenstein" },
    { code: "lt", en: "Lithuania", se: "Litauen" },
    { code: "lu", en: "Luxembourg", se: "Luxemburg" },
    { code: "mo", en: "Macau", se: "Macau" },
    { code: "mg", en: "Madagascar", se: "Madagaskar" },
    { code: "mk", en: "North Macedonia", se: "Makedonien" },
    { code: "mw", en: "Malawi", se: "Malawi" },
    { code: "my", en: "Malaysia", se: "Malaysia" },
    { code: "mv", en: "Maldives", se: "Maldiverna" },
    { code: "ml", en: "Mali", se: "Mali" },
    { code: "mt", en: "Malta", se: "Malta" },
    { code: "ma", en: "Morocco", se: "Marocko" },
    { code: "mh", en: "Marshall Islands", se: "Marshallöarna" },
    { code: "mq", en: "Martinique", se: "Martinique" },
    { code: "mr", en: "Mauritania", se: "Mauretanien" },
    { code: "mu", en: "Mauritius", se: "Mauritius" },
    { code: "yt", en: "Mayotte", se: "Mayotte" },
    { code: "mx", en: "Mexico", se: "Mexiko" },
    { code: "fm", en: "Micronesia", se: "Mikronesiska federationen" },
    { code: "md", en: "Moldova", se: "Moldavien" },
    { code: "mc", en: "Monaco", se: "Monaco" },
    { code: "mn", en: "Mongolia", se: "Mongoliet" },
    { code: "me", en: "Montenegro", se: "Montenegro" },
    { code: "ms", en: "Montserrat", se: "Montserrat" },
    { code: "mz", en: "Mozambique", se: "Moçambique" },
    { code: "na", en: "Namibia", se: "Namibia" },
    { code: "nr", en: "Nauru", se: "Nauru" },
    { code: "nl", en: "Netherlands", se: "Nederländerna" },
    // Removed obsolete 'an' (Netherlands Antilles)
    { code: "np", en: "Nepal", se: "Nepal" },
    { code: "ni", en: "Nicaragua", se: "Nicaragua" },
    { code: "ne", en: "Niger", se: "Niger" },
    { code: "ng", en: "Nigeria", se: "Nigeria" },
    { code: "nu", en: "Niue", se: "Niue" },
    { code: "kp", en: "North Korea", se: "Nordkorea" },
    { code: "mp", en: "Northern Mariana Islands", se: "Nordmarianerna" },
    { code: "nf", en: "Norfolk Island", se: "Norfolkön" },
    { code: "no", en: "Norway", se: "Norge" },
    { code: "nc", en: "New Caledonia", se: "Nya Kaledonien" },
    { code: "nz", en: "New Zealand", se: "Nya Zeeland" },
    { code: "om", en: "Oman", se: "Oman" },
    { code: "pk", en: "Pakistan", se: "Pakistan" },
    { code: "pw", en: "Palau", se: "Palau" },
    { code: "pa", en: "Panama", se: "Panama" },
    { code: "pg", en: "Papua New Guinea", se: "Papua Nya Guinea" },
    { code: "py", en: "Paraguay", se: "Paraguay" },
    { code: "pe", en: "Peru", se: "Peru" },
    { code: "pn", en: "Pitcairn Islands", se: "Pitcairnöarna" },
    { code: "pl", en: "Poland", se: "Polen" },
    { code: "pt", en: "Portugal", se: "Portugal" },
    { code: "pr", en: "Puerto Rico", se: "Puerto Rico" },
    { code: "qa", en: "Qatar", se: "Qatar" },
    { code: "ro", en: "Romania", se: "Rumänien" },
    { code: "rw", en: "Rwanda", se: "Rwanda" },
    { code: "ru", en: "Russia", se: "Ryssland" },
    { code: "re", en: "Réunion", se: "Réunion" },
    { code: "kn", en: "Saint Kitts and Nevis", se: "Saint Kitts och Nevis" },
    { code: "lc", en: "Saint Lucia", se: "Saint Lucia" },
    { code: "vc", en: "Saint Vincent and the Grenadines", se: "Saint Vincent och Grenadinerna" },
    { code: "bl", en: "Saint Barthélemy", se: "Saint-Barthélemy" },
    { code: "pm", en: "Saint Pierre and Miquelon", se: "Saint-Pierre och Miquelon" },
    { code: "sb", en: "Solomon Islands", se: "Salomonöarna" },
    { code: "ws", en: "Samoa", se: "Samoa" },
    { code: "sm", en: "San Marino", se: "San Marino" },
    { code: "sh", en: "Saint Helena", se: "Sankta Helena" },
    { code: "sa", en: "Saudi Arabia", se: "Saudiarabien" },
    { code: "ch", en: "Switzerland", se: "Schweiz" },
    { code: "sn", en: "Senegal", se: "Senegal" },
    { code: "rs", en: "Serbia", se: "Serbien" },
    { code: "sc", en: "Seychelles", se: "Seychellerna" },
    { code: "sl", en: "Sierra Leone", se: "Sierra Leone" },
    { code: "sg", en: "Singapore", se: "Singapore" },
    { code: "sk", en: "Slovakia", se: "Slovakien" },
    { code: "si", en: "Slovenia", se: "Slovenien" },
    { code: "so", en: "Somalia", se: "Somalia" },
    { code: "es", en: "Spain", se: "Spanien" },
    { code: "lk", en: "Sri Lanka", se: "Sri Lanka" },
    { code: "gb", en: "United Kingdom", se: "Storbritannien" },
    { code: "sd", en: "Sudan", se: "Sudan" },
    { code: "sr", en: "Suriname", se: "Surinam" },
    { code: "sj", en: "Svalbard and Jan Mayen", se: "Svalbard och Jan Mayen" },
    { code: "se", en: "Sweden", se: "Sverige" },
    { code: "sz", en: "Eswatini", se: "Swaziland" },
    { code: "za", en: "South Africa", se: "Sydafrika" },
    { code: "kr", en: "South Korea", se: "Sydkorea" },
    { code: "sy", en: "Syria", se: "Syrien" },
    { code: "st", en: "São Tomé and Príncipe", se: "São Tomé och Príncipe" },
    { code: "tj", en: "Tajikistan", se: "Tadzjikistan" },
    { code: "tw", en: "Taiwan", se: "Taiwan" },
    { code: "tz", en: "Tanzania", se: "Tanzania" },
    { code: "td", en: "Chad", se: "Tchad" },
    { code: "th", en: "Thailand", se: "Thailand" },
    { code: "cz", en: "Czech Republic", se: "Tjeckien" },
    { code: "tg", en: "Togo", se: "Togo" },
    { code: "tk", en: "Tokelau", se: "Tokelauöarna" },
    { code: "to", en: "Tonga", se: "Tonga" },
    { code: "tt", en: "Trinidad and Tobago", se: "Trinidad och Tobago" },
    { code: "tn", en: "Tunisia", se: "Tunisien" },
    { code: "tr", en: "Turkey", se: "Turkiet" },
    { code: "tm", en: "Turkmenistan", se: "Turkmenistan" },
    { code: "tc", en: "Turks and Caicos Islands", se: "Turks- och Caicosöarna" },
    { code: "tv", en: "Tuvalu", se: "Tuvalu" },
    { code: "de", en: "Germany", se: "Tyskland" },
    { code: "us", en: "United States", se: "USA" },
    { code: "um", en: "U.S. Minor Outlying Islands", se: "USA:s yttre öar" },
    { code: "ug", en: "Uganda", se: "Uganda" },
    { code: "ua", en: "Ukraine", se: "Ukraina" },
    { code: "hu", en: "Hungary", se: "Ungern" },
    { code: "uy", en: "Uruguay", se: "Uruguay" },
    { code: "uz", en: "Uzbekistan", se: "Uzbekistan" },
    { code: "vu", en: "Vanuatu", se: "Vanuatu" },
    { code: "va", en: "Vatican City", se: "Vatikanstaten" },
    { code: "ve", en: "Venezuela", se: "Venezuela" },
    { code: "vn", en: "Vietnam", se: "Vietnam" },
    { code: "by", en: "Belarus", se: "Vitryssland" },
    { code: "eh", en: "Western Sahara", se: "Västsahara" },
    { code: "wf", en: "Wallis and Futuna", se: "Wallis- och Futunaöarna" },
    { code: "zm", en: "Zambia", se: "Zambia" },
    { code: "zw", en: "Zimbabwe", se: "Zimbabwe" },
    { code: "ax", en: "Åland Islands", se: "Åland" },
    { code: "at", en: "Austria", se: "Österrike" },
    { code: "tl", en: "Timor-Leste", se: "Östtimor" }
];
